import React, { useState } from "react";
import "../services.css";

export const Services = (props) => {

  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDivClick = (details) => {
    setModalData(details);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>

          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`}
                className="col-sm-6 col-md-6 col-lg-6"
                onClick={() => handleDivClick(d)}
                style={{ cursor: "pointer" }}>
                {" "}
                <i className={d.icon}></i>
                <div className="service-desc">
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
      {isModalOpen && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <h3>{modalData.name}</h3>
            <div className="section-label">Achievements</div>
            {Array.isArray(modalData.details) ? (
              <ul>
                {modalData.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </ul>
            ) : (
              <p>{modalData.details}</p>
            )}
            <div className="section-label">References</div>
            {/* <div className="references"> */}
            {Array.isArray(modalData.footer) ? (
              modalData.footer.map((footer, index) => (
                <a
                  key={index}
                  href={footer}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="reference-link"
                >
                  {footer}
                </a>
              ))
            ) : (
              <p className="reference-link">{modalData.footer}</p>
            )}
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

// Inline styles for the modal (you can replace this with CSS)
const modalStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

// const modalContentStyles = {
//   backgroundColor: "#fff",
//   padding: "20px",
//   borderRadius: "8px",
//   width: "80%",
//   maxWidth: "500px",
//   textAlign: "center",
// };

// const closeButtonStyles = {
//   position: "absolute",
//   top: "10px",
//   right: "10px",
//   fontSize: "20px",
//   cursor: "pointer",
// };
